import { render, staticRenderFns } from "./EstoqueCritico.vue?vue&type=template&id=61792d8f&scoped=true"
import script from "./EstoqueCritico.vue?vue&type=script&lang=js"
export * from "./EstoqueCritico.vue?vue&type=script&lang=js"
import style0 from "./EstoqueCritico.vue?vue&type=style&index=0&id=61792d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61792d8f",
  null
  
)

export default component.exports